<!-- ModalSaveCar -->
<div class="modal fade rtl" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-lg">

        <div class="modal-content">

            <div class="modal-header">

                <h5 class="modal-title d-flex align-content-center text-th-blue" id="exampleModalLabel">

                    <span class="ms-2">ثبت خودرو</span>

                    <i class="fa fa-question-circle fa-2x pointer" (click)="guideRequested.emit()"></i>

                </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body d-flex flex-column flex-md-row justify-content-center align-items-center"
                [formGroup]="form" *ngIf="access?.bEnableAddCar">

                <!-- ثبت خودرو با ردیاب -->

                <div class="col-12 col-md-auto form-check align-items-center d-flex flex-column" *ngIf="access?.bAddGPS">

                    <label class="form-check-label d-flex justify-content-center align-items-center flex-column pointer"
                        for="flexRadioDefault1">

                        <img src="../../../assets/Img/car-gps.png" height="80px">

                        <span>ثبت خودرو با ردیاب</span>

                    </label>

                    <input class="form-check-input" type="radio" id="flexRadioDefault1" value="1" formControlName="gps">

                </div>

                <!-- خودرو اداری  -->

                <div class="col-12 col-md-auto form-check align-items-center d-flex flex-column" *ngIf="access?.bAddGPS">

                    <label class="form-check-label d-flex justify-content-center align-items-center flex-column pointer"
                        for="flexRadioDefault3">

                        <div style="height: 80px;" class="d-flex justify-content-center align-items-center">

                            <img src="../../../assets/Img/car-office.png" height="60px">

                        </div>

                        <span>ثبت خودرو اداری</span>

                    </label>

                    <input class="form-check-input" type="radio" id="flexRadioDefault3" value="3" formControlName="gps">

                </div>

                <!-- ثبت خودرو بدون ردیاب -->

                <div class="col-12 col-md-auto form-check align-items-center d-flex flex-column" *ngIf="access?.bAddNGPS">

                    <label class="form-check-label d-flex justify-content-center align-items-center flex-column pointer"
                        for="flexRadioDefault2">

                        <img src="../../../assets/Img/car-no-gps.png" height="80px">

                        <span>ثبت خودرو بدون ردیاب</span>

                    </label>

                    <input class="form-check-input" type="radio" value="2" id="flexRadioDefault2" formControlName="gps">

                </div>


            </div>

            <div class="modal-footer">

                <button type="button" class="btn btn-success" (click)="submitted.emit()">

                    تایید

                    <i class="fa fa-angle-double-down"></i>

                </button>

                <button type="button" class="btn btn-primary " data-bs-dismiss="modal">

                    بستن

                    <i class="fa fa-close"></i>

                </button>

            </div>

        </div>

    </div>

</div>
